import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';

export const useDocumentModal = () => {
  const { params, setQueryParams } = useQueryParams();
  const isOpen = params[queryKeys.activeModal] === queryValues.documentModal;
  const activeDocumentId = params[queryKeys.documentId];

  const openModal = (id: string) => {
    setQueryParams({
      [queryKeys.activeModal]: queryValues.documentModal,
      [queryKeys.documentId]: id,
    });
  };

  const closeModal = () => {
    setQueryParams({
      [queryKeys.activeModal]: undefined,
      [queryKeys.documentId]: undefined,
    });
  };

  return { isOpen, activeDocumentId, openModal, closeModal };
};
